import { render, staticRenderFns } from "./PageHRDocuments.vue?vue&type=template&id=2c81aba2&"
import script from "./PageHRDocuments.vue?vue&type=script&lang=js&"
export * from "./PageHRDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports